import axios from 'axios';
import AppConfig from "../../../../../AppConfig";

let URL = AppConfig.HOST_API()+'ekipy/';

export default {

    getEkipy() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    addEkipa(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editEkipa(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteEkipa(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },

    getEkipa(id){
        return axios({
            method: 'get',
            url: URL + id,
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipy/definicjaEkipy/EkipyService.js